export const VERSION = '0.24.3'; // x-release-please-version
//# sourceMappingURL=version.mjs.map